<wiz-vgroup height="100%" width="100%" padding="5px" class="section-container">
  <wiz-hgroup width="100%" verticalAlign="end" gap="10">
    <wiz-dropdown
      #ddSteps
      width="150px"
      [wizLabel]="'$.vision.steps.$'"
      [wizDataProvider]="stepDS"
      [wizLabelField]="'visionAndStep'"
    ></wiz-dropdown>
    <wiz-label #lblResult style="padding-bottom: 10px"></wiz-label>
  </wiz-hgroup>

  <tool-pivot-component
    #pivotSample
    width="100%"
    height="100%"
    [model]="model"
    [uid]="'incexc-sample'"
    [pivotMode]="false"
    [templatingMode]="true"></tool-pivot-component>
</wiz-vgroup>
